import { render, staticRenderFns } from "./GamesetDetail.vue?vue&type=template&id=d0251e0a&scoped=true&"
import script from "./GamesetDetail.vue?vue&type=script&lang=js&"
export * from "./GamesetDetail.vue?vue&type=script&lang=js&"
import style0 from "./GamesetDetail.vue?vue&type=style&index=0&id=d0251e0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0251e0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
